import { Router } from '@angular/router';
import {
  Component,
  OnInit,
  OnDestroy,
  TemplateRef,
  EventEmitter,
} from '@angular/core';

import { BsDropdownConfig } from 'ngx-bootstrap/dropdown';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { Announcement } from '../../../../../models';
import {
  EventBusService,
  AuthenticationService,
  AnnouncementService,
} from '../../../../../services';
import routeTable from '../../../../../utility/routeTable';
import constants from '../../../../../utility/constants';
import {  Subscription } from 'rxjs';
@Component({
  selector: 'app-public-header',
  templateUrl: './public-header.component.html',
  styleUrls: ['./public-header.component.css'],
  providers: [
    {
      provide: BsDropdownConfig,
      useValue: { isAnimated: true, autoClose: true },
    },
  ],
})
export class PublicHeaderComponent implements OnInit, OnDestroy {
  openEventRegistrationModal: EventEmitter<any> = new EventEmitter();
  modalRef: BsModalRef;
  showCovidWarning = true;
  showNavBar = false;
  loggedIn: boolean;
  user: any;
  firstName: string;
  lastName: string;
  announcement: Announcement;
  role: any;
  name = 'Sign In';
  private subscriptions: Array<Subscription> = [];

  routes = routeTable.public;
  roles = constants.common.loginType;
  private readonly userTypes = constants.common.loginType;

  constructor(
    private modalService: BsModalService,
    private ebs: EventBusService,
    private as: AuthenticationService,
    private announcementService: AnnouncementService,
    public router: Router
  ) {
    const loggedInName = this.as.getLoggedInName.subscribe((name: any) => {
      if (name == 'Sign In') {
        this.loggedIn = false;
      }
    });
    this.subscriptions.push(loggedInName)
  }

  ngOnInit(): void {
    this.addHeaderScrollEvent();
    this.loggedIn = this.as.checkLoggedIn();
    this.role =
      this.as.currentBuyerValue() === null
        ? 'Buyer'
        : this.as.currentBuyerValue()?.user?.role?.name;
    if (this.loggedIn == true) {
      this.user = this.as.currentBuyerValue()?.user;
      this.firstName = this.user?.firstName;
      this.lastName = this.user?.lastName;
    }
    const notification = this.ebs.notification.subscribe((res) => {
      if (res == 'user-dashboard') {
        this.loggedIn = this.as.checkLoggedIn();
      }
    });
    this.subscriptions.push(notification)
    const getName = this.ebs.getName().subscribe((name) => {
      this.firstName = name.split(' ')[0];
      this.lastName = name.split(' ')[1];
      if (name) {
        this.loggedIn = this.as.checkLoggedIn();
        this.role =
          this.as.currentBuyerValue() === null
            ? 'Buyer'
            : this.as.currentBuyerValue()?.user?.role?.name;
      }
    });
    this.subscriptions.push(getName)
    this.getAnnoucement();
  }

  getAnnoucement() {
    const getAnnouncement = this.announcementService.getAnnouncements().subscribe((response) => {
      this.announcement = response;
    });
    this.subscriptions.push(getAnnouncement)
  }

  openModal(template: TemplateRef<any> | string) {
    this.modalRef = this.modalService.show(
      template,
      Object.assign(
        {},
        {
          class: 'custom-popup user-login modal-dialog modal-dialog-centered',
        }
      )
    );
  }
  openModalFile(modalName: String) {
    this.ebs.notification.emit(modalName);
  }
  fixHeaderPosition() {
    let headerElement = document.getElementsByTagName('header')[0];
    let bodyElement = document.body;
    var top =
      (window.pageYOffset || document.documentElement.scrollTop) -
      (document.documentElement.clientTop || 0);
    if (headerElement.offsetTop <= top && top > 1) {
      headerElement.classList.add('header-fixed');
      bodyElement.style.paddingTop = headerElement.clientHeight + 'px';
    } else {
      headerElement.classList.remove('header-fixed');
      bodyElement.style.paddingTop = '0';
    }
  }

  addHeaderScrollEvent() {
    document.addEventListener('scroll', this.fixHeaderPosition);
  }

  removeHeaderScrollEvent() {
    document.removeEventListener('scroll', this.fixHeaderPosition);
  }

  ngOnDestroy() {
    this.removeHeaderScrollEvent();
    this.subscriptions.forEach((sub: Subscription) => {
      sub.unsubscribe();
    });
  }

  logout() {
    this.as.logout(this.userTypes.public);
    this.loggedIn = false;
  }
}
